export const da = {
    admin: {
        user: 'Kundemodusvisning',
        userModeDescription:
            'Ved at aktivere denne modus vil siden forhåndsvises, som den bliver præsenteret for kundene.',
    },
    app: {
        forvalter: 'Dashbord for fast ejendom',
        mittleieforhold: 'Min lejekontrakt',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        d365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Logger ind...',
        loggingOut: 'Logger ud...',
        login: 'Log ind',
        logout: 'Log ud',
        privacyDescription:
            'Ved at bruge denne side accepterer du, at vi indsamler oplysninger, der bruges til at forbedre ' +
            'brugeroplevelsen for brugerne af denne side. Læs om behandlingen af ​​personoplysninger i Min lejekontrakt i vores ',
        privacyLinkTitle: 'privatlivspolitik.',
        sessionTimeout: 'Din session er udløbet',
        sessionTimeoutLoginAgain: 'Log ind igen',
    },
    breadcrumbs: {
        building: 'Lokaler',
        byggUtleie: 'Utleie',
        contract: 'Kontraktsforhandling',
        dashboard: 'Min lejekontrakt',
        invoice: 'Faktura',
        listUsers: 'Brugere',
        message: 'Opslagstavle',
        registerUser: 'Registrér bruger',
        searchUsers: 'Søg efter brugere',
        selectClient: 'Vælg kundeforhold',
        ticket: 'Sager',
    },
    buildingClientChooser: {
        groupByBuilding: 'Grupper efter ejendom ',
        groupByClient: 'Grupper efter kunde ',
        recipients: {
            all: 'Alle modtagere',
            search: 'Søk blandt modtagerne',
            select: 'Modtagere',
            selected: 'Valgte modtagere',
        },
    },
    bygg: {
        activeClients: 'Aktive kunder',
        adresse: 'Adresse',
        andelFossilEl: 'Andel af fossil/el',
        arealType: 'Type',
        backToOverview: 'Tilbage til ejendomsoversigt',
        backToOverviewForClient: 'Tilbage til ejendomme for {{customerName}}',
        beskrivelse: 'Om ejendommen',
        bygg: 'Ejendom',
        byggeAar: 'Byggeår',
        byggInfo: {
            numberOfBuildings: '{{count}} lokaler',
            numberOfBuildings_1: '{{count}} lokale',
            numberOfContracts: '{{count}} aftaler',
            numberOfContracts_1: '{{count}} aftale',
        },
        byggListTitle: 'Mine ejendomme',
        byggListTitleAdmin:
            'Ejendomme for {{customerName}} ({{customerNumber}})',
        byggListTitleAdminAllBuildings: 'Alle ejendomme',
        byggNummer: 'Bygningsnummer',
        byggSearch: 'Søg ejendom',
        contractDetails: 'Økonomi',
        customers: 'Kunder',
        documents: 'Dokumenter og tegninger',
        driftsAnsvarlig: 'Driftsansvarlig',
        driftsTekniker: 'Driftstekniker',
        eiendomsAnsvarlig: 'Ejendomsmanager',
        eiendomsNummer: 'Ejendomsnummer',
        energiForbruk: 'Estimeret energiforbrug',
        energiKarakter: 'Energiklasse',
        errorList: {
            description: 'Der gik noget galt, da man indlæste ejendomme.',
            title: 'Der gik noget galt, da man indlæste ejendomme.',
        },
        errorNoClients: {
            title: 'Ingen kunder fundet for denne ejendom.',
        },
        errorNotFound: {
            description: 'Ingen ejendomme fundet',
            title: 'Ingen ejendomme fundet',
        },
        errorSingle: {
            description: 'Der gik noget galt, da man indlæste en ejendommen.',
            title: 'Der gik noget galt, da man indlæste en ejendommen.',
        },
        etasjer: 'Etager',
        forbruk: 'Miljøprofil',
        futureClients: 'Kommende kunder',
        gabNummer: 'GAB-nummer',
        inactiveClients: 'Inaktive kunder',
        kompleksNummer: 'Kompleksnummer',
        name: 'Navn',
        overview: 'Oversigt',
        searchDocument: {
            placeholder: 'Skriv dit nøgleord her',
            title: 'Søg i dokumenter',
        },
        showAll: 'Vis alle ejendomme',
        tickets: 'Sager',
        totAreal: 'Areal',
        shortcut: 'Genvej',
    },
    byggCalendar: {
        name: 'Kalender',
        error: {
            title: 'Noget gik galt',
            description:
                'Vi har problemer med at vise kalenderen for denne ejendom lige nu. Prøv igen om lidt.',
        },
    },
    byggDokument: {
        errorDownload: {
            description: 'Der gik noget galt ved indlæsning af dokumenter.',
            title: 'Der gik noget galt ved indlæsning af dokumenter.',
        },
        errorNotFound: {
            description: 'Ingen dokumenter fundet.',
            title: 'Ingen dokumenter fundet.',
        },
        tableTitle: {
            generalInfo: 'Generel information',
            contractAttachment: 'Bilag til kontrakter',
            fire: 'Brand',
            escape: 'Flugt',
        },
        etasje: 'Etage',
        maalestokk: 'Målestok',
        navn: 'Navn',
        nummer: 'Nummer',
        revdato: 'Revision',
    },
    byggUtleie: {
        areaAvailable: 'Ledigt område',
        areaLeased: 'Lejet område',
        areaRatio: 'Arealmæssigt udleiegrad',
        areaToExpire: 'Udløbsområde',
        available: 'Ledigt',
        econRatio: 'Økonomisk udleiegrad',
        expires: 'Udløber',
        expiring: 'Utgående kontrakter',
        leased: 'Lejed ud',
        menu: 'Utleie',
        title: 'Ejendom utleie',
        vacant: 'Ledige lokaler per {{from}}',
    },
    clientSelect: {
        chooseClient: 'Vælg kundeforhold',
        clientName: 'Kundenavn',
        clientNumber: 'Kundenummer',
        clientLastActiveInML: 'Sidst aktiv i Min lejekontrakt',
        errorNoClients: {
            description: 'Kontakt os for at løse dette.',
            title: 'Du har intet aktivt kundeforhold.',
        },
        errorNoClientsSelected: {
            description: 'For at se data skal du først vælge dit kundeforhold.',
            title: 'Der er ikke valgt noget kundeforhold.',
        },
        notFound: 'Ingen kunder fundet.',
        searchClient: 'Søg efter kunde',
        selectAktiveOnly: 'Søg kun efter kunder med aktive kontrakter',
        selectedClient: 'Valgt kunde: {{customerName}}',
        welcomeMessageSent: 'Velkomstbesked sendt',
    },
    contractManagement: {
        title: 'Kontrakter',
        leko: 'Forhandlinger',
        avtaler: 'Mine aftaler',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Åbne kontraktforhandling',
            contractNotFoundTitle: 'Leder du efter dine lejevilkår?',
            contractNotFoundDescription:
                'Du kan finde alle dine ejendommes aktuelle lejevilkår under den respektive bygning',
            contractNotFoundLink: 'Gå til mine ejendomme',
            manualContractDescription:
                'Du kan få en kopi af dine kontrakter i PDF-form ved at kontakte din ejendomsadministrator i KLP',
            manualContractTitle: 'Leder du efter et eksisterende PDF-kontrakt?',
            title: 'Kontraktforhandling skal åbnes i en ny fane',
            description:
                'For at åbne Kontraktforhandlingerne skal vi bruge en ny fane',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Åbne beslutningsportal',
            description:
                'For at åbne beslutningsportalen, skal vi bruge en ny fane',
            title: 'Skal du tilpasse dit nye værelse?',
        },
    },
    leaseAgreement: {
        table: {
            property: 'Ejendom',
            propertyNumber: 'Ejendoms Nr.',
            propertyName: 'Ejendom',
            name: 'Navn',
            quantity: 'Areal',
            leaseFromDate: 'Fra',
            leaseToDate: 'Til',
            contractNumber: 'Kontrakt Nr.',
            notFound: 'Ingen aftaler fundet.',
        },
        title: 'Mine aftaler',
        activeAgreement: 'Aktive aftaler',
        archivedAgreement: 'Tidligere aftale',
        futureAgreement: 'Fremtidige aftaler',
        errorDownload: {
            description: 'Der gik noget galt, da man indlæste aftaler.',
            title: 'Der gik noget galt, da man indlæste aftaler.',
        },
    },
    environment: {
        description:
            'Denne service kan være ustabil i nogle perioder.' +
            'Vi udvikler og forbedrer vores tjeneste hele tiden, og vi værdsætter alle dine forslag og feedback.',
        dev: 'DEV',
        environment: 'Miljø: ',
        local: 'Lokal',
        test: 'TEST',
    },
    faktura: {
        amount: 'Beløb',
        betalingsgrad: 'Betalingsgrad',
        inkasso: 'Inkasso',
        purring: 'Påmindelse',
        delayed: 'Forsinket',
        delayedPayments: 'Forsinket betalinger',
        delayedPayments_0: 'Forsinket betaling',
        dueDate: 'Forfaldsdato',
        errorDownload: {
            description: 'Der gik noget galt ved indlæsning af fakturaer.',
            title: 'Der gik noget galt ved indlæsning af fakturaer.',
        },
        errorNotFound: {
            description: 'Ingen fakturaer fundet.',
            title: 'Ingen fakturaer fundet.',
        },
        emptyTable: 'Ingen fakturaer matcher din søgning.',
        faktura: 'Fakturaer',
        faktura_1: 'Faktura',
        fakturaNumber: 'Fakturanummer',
        incomingPayments: 'Kommende betalinger',
        incomingPayments_0: 'Kommende betaling',
        invoiceNumberShort: 'Nr',
        invoicesFor: 'Fakturaer for {{kundeName}} ({{kundeNummer}})',
        invoiceSummary: 'Sum: {{sum}}kr hvoraf forsinket: {{delayed}}kr',
        issueDate: 'Fakturadato',
        lastpaymentdate: 'Sidst betalt',
        left: 'Rest udestående',
        myInvoices: 'Mine fakturaer',
        notSettledInvoices: 'Ubetalte fakturaer',
        notSettledInvoices_1: 'Ubetalt faktura',
        paid: 'Innbetalt',
        payments: 'Betalinger',
        refunds: 'Kreditnota',
        settledInvoice_0: 'Betalt faktura',
        settledInvoices: 'Betalte fakturaer',
        status: 'Status',
    },
    fakturaStatus: {
        AwaitingPayment: 'Skal betales',
        AwaitingRefund: 'Skal refunderes',
        Refunded: 'Refunderes',
        Paid: 'Betalt',
        PartiallyPayed: 'Delbetalt',
        Overdue: 'Overskredet',
        Unknown: 'Ukendt',
    },
    file: {
        deleting: 'Sletning af filer...',
        deleting_1: 'Sletter fil...',
        downloading: 'Henter...',
        fileNotFound: 'Filen findes ikke',
        preview: 'Forhåndsvisning',
        previewDownload: 'Forhåndsvisning / Last ned',
        saving: 'Gemmer filerne...',
        saving_1: 'Gemmer filen...',
        selectFiles: 'Vælg filer',
        selectFiles_0: 'Vælg fil',
        downloadFailed: 'Download mislykkedes',
        downloadSuccess: 'Filen er downloadet',
    },
    footer: {
        contactIntro: 'Vi hjælper dig',
        email: {
            prefix: 'E-Mail: ',
            text: 'Skriv til os',
            url: {
                default: 'mailto:kundeogmiljosenter@klpeiendom.no',
                sv: 'mailto:info@klpfastigheter.se',
                da: 'mailto:kbh@klp.no',
            },
        },
        openingHours: {
            default: 'Døgnbemannet',
            sv: 'Åbent hele døgnet',
            da: 'Åbent hele døgnet',
        },
        phone: {
            prefix: 'Døgnåpen telefon: ',
            default: {
                title: '23 08 08 14',
                url: 'tel:+4723080814',
            },
            sv: {
                title: '08-657 77 56',
                url: 'tel:+468100160',
            },
            da: {
                title: '(+45) 82 82 35 35',
                url: 'tel:+4582823535',
            },
        },
        privacy: {
            description: 'Privatliv, klageadgang og sikkerhed',
            url: {
                default:
                    'https://www.klpeiendom.no/oslo/om-klp-eiendom/personvern',
                sv: 'https://www.klpfastigheter.se/stockholm/om-oss/personuppgifter',
                da: 'https://www.klpejendomme.dk/kobenhavn/om-os/persondatapolitik',
            },
        },
        newSak: {
            text: 'Registrér en ny sag',
            link: 'https://mittleieforhold.klpeiendom.no/sak/add',
        },
    },
    frontPage: {
        accountSettings: 'Kontoindstillinger',
        buildings: 'Lokaler',
        buildingsLink: 'Mine lokaler',
        contract: 'Kontrakter',
        contractManagement: {
            subtitle: 'Forhandle en ny lejeaftale?',
            contractNegotiation: 'Kontraktforhandling',
        },
        dxboProject: 'Beslutningsportal',
        frontpage: 'Forside',
        invoice: {
            title: 'Faktura',
            invoiceLink: 'Fakturaer',
            sumOutstanding: 'Sum udestående: ',
            outstandingInvoiceCount: 'Faktura: {{outstandingInvoiceCount}} stk',
            outstanding: 'Kommende faktura',
        },
        messages: 'Opslagstavle',
        messagesLink: 'Se alle beskeder',
        mytasksLink: 'Sagsoversigt',
        errorReporting: 'Fejlrapport',
        newsFeed: {
            title: 'Seneste fra KLP Ejendomme:',
            linkText: 'Se mere fra KLP Ejendomme på LinkedIn',
        },
        twoFactorAlertText: 'Tofaktorautentificering tilgængelig',
        boldTwoFactorAlertText: ' - Aktiver i kontoindstillinger!',
        welcome: {
            forvalter: 'Velkommen til Dashbordet for fast ejendom',
            mittleieforhold: 'Velkommen til Min lejekontrakt',
            yourAdminDashboard:
                'Velkommen til dit fast ejendom Dashbord{{name}}',
        },
        miljo: {
            title: 'Miljø',
        },
        sustainability: {
            title: 'Bæredygtighed',
        },
        miljoprofil: {
            title: 'Byggets miljøprofil',
        },
    },
    editor: {
        paragraph: 'Afsnit',
        heading1: 'Overskrift 1',
        heading2: 'Overskrift 2',
        heading3: 'Overskrift 3',
        heading4: 'Overskrift 4',
        heading5: 'Overskrift 5',
        heading6: 'Overskrift 6',
        horizontalRule: 'Horisontal linje',
        insertTable: 'Indsæt tabel',
        loadingEditor: 'Indlæser editor...',
        addColumnBefore: 'Tilføj kolonne før',
        addColumnAfter: 'Tilføj kolonne efter',
        deleteColumn: 'Slet kolonne',
        addRowBefore: 'Tilføj række før',
        addRowAfter: 'Tilføj række efter',
        deleteRow: 'Slet række',
        deleteTable: 'Slet tabel',
    },
    general: {
        adminContent: 'Dette er kun synligt for administratorbrugere',
        backToTop: 'Tilbage til toppen',
        by: 'af',
        cancel: 'Afbryd',
        clear: 'Tøm',
        clearList: 'Ryd listen',
        clearSelection: 'Ryd markeringen',
        close: 'Luk',
        confirm: 'Ja',
        days: 'dage',
        days_0: 'dag',
        decline: 'Nej',
        delete: 'Slet',
        details: 'Detaljer',
        download: 'Hent',
        draft: 'Kladde',
        edit: 'Redigér',
        emptyList: 'Listen er tom',
        successfulOperation: 'Handlingen blev udført med succes.',
        error: 'Fejl',
        errorMessage: 'Der opstod en fejl. \n Prøv igen senere.',
        expired: 'Udløbet',
        goBack: 'Gå tilbage',
        goBackToFrontpage: 'Vend tilbage til forsiden',
        loading: 'Laster...',
        deleting: 'Sletter...',
        menu: 'Menu',
        month: 'Måned',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'Maj',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Okt',
        month_10: 'Nov',
        month_11: 'Des',
        noIe:
            'Vi beklager, men denne funktion understøttes ikke i Internet Explorer. ' +
            'Vi anbefaler at bruge Google Chrome eller Mozilla Firefox browser.',
        of: 'af',
        open: 'Åbn',
        outdatedBrowser: {
            description:
                'Kære bruger! Din browser er forældet, og nogle af funktionerne fungerer muligvis ikke korrekt. Vi anbefaler at bruge Google Chrome eller Mozilla Firefox-browseren.',
            title: 'Utdatert nettleser',
        },
        pageNotFound: 'Kunne ikke finde siden',
        preview: 'Preview',
        previewDownload: 'Preview / Hent',
        publish: 'Publicér',
        readMore: 'Læs mere',
        reload: 'Genindlæs',
        reset: 'Nulstil',
        save: 'Gem',
        saveAsDraft: 'Gem som kladde',
        saved: 'Gemt',
        saving: 'Gemmer...',
        show: 'vis',
        showAll: 'Vis alle',
        submit: 'Indsend',
        sum: 'sum',
        updating: 'Opdatering...',
        wrote: 'skrev',
    },
    kontrakt: {
        agreements: 'kontrakter',
        agreements_1: 'kontrakt',
        agreementRows: 'linjer',
        agreementRows_1: 'linje',
        antall: 'Størrelse',
        antenne: 'Antenne',
        'annet uten fellesar': 'Andet uden fællesområde',
        arkiv: 'Arkiv',
        arligEiendomskatt: 'Årlig eiendomsskat',
        arligFellesKostnad: 'Årlige lejeomkostninger',
        arligLeie: 'Årlig leje',
        bod: 'Skur',
        bolig: 'Bolig',
        butikk: 'Butik',
        'bygg felles': 'fælles bygning',
        coworking: 'Coworking',
        energiForbrukPrM2: 'Energiforbrug pr. m²',
        errorContractNotFound: {
            description: 'Noget gik galt, da man indlæste kontrakter.',
            title: 'Noget gik galt, da man indlæste kontrakter.',
        },
        errorDownload: {
            description: 'Noget gik galt ved download af kontrakter.',
            title: 'Fejl ved download af kontrakter.',
        },
        felles: 'Fælles',
        felleskostnaderPrM2: 'Fælles omkostninger pr. m²',
        festetomter: 'Fæstegrunde',
        forretning: 'Forretning',
        'forretning uten fel': 'Forretning uden fællesområde',
        fra: 'Fra',
        garasje: 'Garage',
        'garasje uten felles': 'Garage uden fællesområde',
        gyldigFra: 'Gyldig fra',
        gyldigTil: 'Gyldig til',
        hotell: 'Hotel',
        'kantine areal': 'Kantineområde',
        kantine: 'Kantine',
        kontor: 'Kontor',
        kontrakt: 'Kontrakt',
        kontraktAgreements: 'Kontrakter',
        kontraktAgreementsActive: 'Aktive kontrakter',
        kontraktAgreementsInfobox:
            'Denne side viser kun aktive kontrakter. Fuld oversigt og downloads findes i ',
        kontraktFra: 'Kontrakt fra',
        kontraktNummer: 'Kontraktnummer',
        kontraktsdato: 'Kontraktdato',
        kontraktsnummer: 'Kontraktnummer',
        kontraktTil: 'Kontrakt til',
        kontraktGaranti: 'Garanti',
        kostPrPplassPrAr: 'Pris pr. p-plads per år',
        lager: 'Lager',
        'lager uten fellesar': 'Lager uden fællesareal',
        m2: 'm²',
        unknownFileName: 'ukendt filnavn',
        navn: 'Navn',
        other: 'Andet',
        parkering: 'Parkering',
        pcs: 'stk.',
        pris: 'Pris',
        prisPerAar: 'Årspris',
        perAar: '/år',
        perM2: '/m²',
        perStk: '/stk.',
        pricePerUnit: 'Enhedspris',
        reklameplass: 'Reklameplads',
        relatedFiles: 'Relaterede filer',
        showFiles: 'Vis filer',
        restaurant: 'Restaurant',
        servering: 'Servering',
        teknisk: 'Teknisk',
        'teknisk uten felles': 'Teknisk uden fællesområde',
        til: 'Til',
        fristOppsigelseLeietaker: 'Tidligst mulige dato for opsigelse',
        tomt: 'Grund',
        totaltAreal: 'Totalareal',
        'trening uten felles': 'Træning uden fællesområde',
        verksted: 'Værksted',
        undervisning: 'Undervisning',
        uteservering: 'Udendørsservering',
    },
    languageName: 'Dansk',
    listUsers: {
        adminUserExplanation:
            'Admin bruker har full tilgang til alle data. Kun KLP-brukere kan være admin brukere',
        notRegisteredInSuperOfficeWarning: {
            description:
                'For at du kan se eller registrere brugere til denne kunde, skal kunde først være registreret i SuperOffice',
            superOfficeButtonText: 'Åbne SuperOffice',
            title: 'Denne kunde findes ikke i SuperOffice!',
        },
        superUserExplanation:
            'Superbruker har tilgang til kontrakter og fakturaer. NB! Kunden kan bestemme selv å gi superbruker-tilgang til andre brukere i organisasjonen.',
        superUserExplanationForUser:
            'Superbruker har tilgang til kontrakter og fakturaer. Du kan bestemme selv å gi superbruker-tilgang til andre brukere i din organisasjon.',
        title: 'Brugere',
        usersForCustomer: 'Brugere for {{customer}}',
    },
    message: {
        actions: {
            Deleted: 'Slet',
            Draft: 'Kladd',
            Expired: 'Sæt udløbet',
            Published: 'Udgive',
            WillPublish: 'Indstil udgivelse',
            sendCopyToMe: 'Send e-mailbesked til mig',
        },
        action: 'Handling',
        addMessage: 'Nyt opslag',
        allMessages: 'Alle opslag',
        backButton: 'Tilbage til meddelelsesoversigt',
        download: 'Download opslag',
        category: {
            helperText: 'Vælg opslag type',
            name: 'Type',
        },
        categoryType: {
            Alert: 'Kritisk',
            Info: 'Info',
            Warning: 'Advarsel',
        },
        channel: {
            confirmEmail:
                'Alle modtagere modtager en e-mail-underretning. Vil du sende det?',
            email: 'Send som e-mail',
            infoText: 'E-mailen sendes i løbet af natten.',
            yes: 'Ja, send',
            notificationSent: 'Notifikation sendt til modtagere {{timeSent}}',
            sendTonight: 'Send i aften/nat',
            sendImmediately: 'Send med det samme',
        },
        content: {
            helperText: 'Skriv inn dit opslag',
            name: 'Opslag',
        },
        dialog: {
            Deleted: {
                action: 'Ja, slett',
                description: 'Vil du slette opslaget?',
                title: 'Slett opslaget',
            },
            Draft: {
                action: 'Ja, set som et udkast',
                description: 'Vil du ændre status for udkastet til opslaget?',
                title: 'Sæt som udkast',
            },
            Expired: {
                action: 'Ja, sett som utløpt',
                description: 'Vil du ændre status for udløbet til opslaget?',
                title: 'Udløbet opslag',
            },
            Published: {
                action: 'Ja, udgive',
                description: 'Vil du udgive opslaget?',
                title: 'Publicer opslaget',
            },
        },
        editMessage: 'Redigér opslag',
        errorNoMessagesFound: {
            description: 'Du har ingen opslag lige nu.',
            title: 'Du har ingen opslag lige nu.',
        },
        expiresAt: {
            helperText: 'Vælg udløbsdato, eller lad feltet være tomt',
            name: 'Udløbsdato',
        },
        importantMessages: 'Vigtige opslag',
        isPinned: {
            helperText: 'Du kan fremhæve beskeden i nyhedsfeedet',
            name: 'Fastgør beskeden',
        },
        messageDocuments: {
            helperText:
                'Du kan vælge filer, der skal slettes eller uploade flere filer',
            name: 'Dokumenter',
        },
        messageImages: {
            helperText:
                'Du kan vælge billeder til sletning eller uploade flere billeder',
            name: 'Billeder',
        },
        messagePinned: 'Dette opslag er fremhævet',
        messagesFor: 'Opslag for {{kundeName}} ({{kundeNummer}})',
        messageStatus: 'Status',
        myMessages: 'Mine opslag',
        publishAt: {
            helperText: 'Velg udgivelse dato',
            name: 'Udgivelse dato',
        },
        published: 'Udgivet',
        readMore: 'Læs mere',
        seeAll: 'Læs alle opslag',
        status: {
            Deleted: 'Slettet',
            Draft: 'Kladde',
            Expired: 'Udløbet',
            Published: 'Udgivet',
            WillPublish: 'Skal publiceres',
        },
        title: {
            helperText: 'Indtast titlen',
            name: 'Titel',
        },
        updated: 'Opdateret',
        // deprecated
        uploadedFiles: {
            helperText: 'Du kan vælge filer til sletning',
            name: 'Uploadede filer',
        },
        // deprecated
        uploadFiles: {
            helperText: 'Vælg nye filer, der skal uploades, når du gemmer',
            name: 'Nye filer',
        },
        noMessages: 'Ingen beskeder fundet.',
    },
    registerUser: {
        'A user with the provided e-mail address already exists': {
            description: 'En bruger med denne e-mail-adresse findes allerede.',
            title: 'Der opstod en fejl under registrering af bruger.',
        },
        back: 'Tilbage til brugere',
        disabledTooltip:
            'Knappen er deaktiveret, fordi det ikke er valgt, om en velkomstbesked skal sendes eller ej.',
        email: 'E-mail',
        firstName: 'Fornavn',
        generalError: {
            description:
                'Brugerregistrering mislykkedes. Prøv igen senere eller kontakt os, så hjælper vi dig.',
            title: 'Der opstod en fejl under registrering af bruger.',
        },
        lastName: 'Efternavn',
        registerNew: 'Registrér ny bruger',
        registeringUser: 'Registrerer bruger...',
        successNotification: 'Brugerregistrering var vellykket.',
        title: 'Registrér bruger for {{customer}}',
        roles: {
            title: 'Roller',
            superUserCheckBox:
                'Skal have adgang til kontrakter og fakturaer (superbruger)',
        },
        other: {
            title: 'Andet',
            velkomstmelding: 'Skal der sendes en velkomstbesked?',
            yesButton: 'Ja',
            noButton: 'Nei',
        },
    },
    sak: {
        actions: {
            Active: 'Åbne sag',
            Closed: 'Lukk sag',
            Deleted: 'Slett sag',
            Merged: 'Slå sammen',
            Postponed: 'Utsett sak',
        },
        addSak: 'Ny sag',
        archivedTasksFor:
            'Sager der har blivet arkiveret for {{kundeName}} ({{kundeNummer}})',
        backButton: 'Tilbage til sagsoversigten',
        confirmation: {
            title: 'Henvendelse registreret',
            message:
                'Din henvendelse er registreret. Vi svarer på din sag så hurtigt som muligt.',
        },
        buildingcategory: {
            helperText: 'Vælg ejendomskategori',
            name: 'Ejendomskategori',
        },
        category: {
            helperText: 'Vælg kategori',
            name: 'Kategori',
        },
        created: 'Oprettet dato',
        dialog: {
            Active: {
                action: 'Ja, åpne',
                description: 'Vil du åpne saken?',
                title: 'Åpne sak',
            },
            Closed: {
                action: 'Ja, lukk',
                description: 'Vil du lukke saken?',
                title: 'Lukk besked',
            },
        },
        emne: 'Emne',
        email: 'E-mail',
        emailCopyRecipient: 'Kopi til modtager:',
        errorDownload: {
            description: 'Der gik noget galt ved indlæsning af sager.',
            title: 'Der gik noget galt ved indlæsning af sager.',
        },
        errorNotFound: {
            description: 'Ingen åbne sager fundet.',
            title: 'Ingen åbne sager fundet.',
        },
        noTasks: 'Ingen sager fundet.',
        goBackToSaker: 'Vend tilbage til sager',
        lukketDato: 'Afsluttet',
        melding: 'Besked',
        meldinger: {
            melding: {
                helperText: 'Skriv ditt svar',
                name: 'Svar',
            },
            noMoreMessages: 'Ikke flere beskeder.',
            sendSvar: 'Send svar',
        },
        myArchivedTasks: 'Mine sager der har blivet arkiveret',
        myTasks: 'Mine sager',
        openArchive: 'Åbne sagsarkiv',
        openSakList: 'Åbne sager',
        opprettetAv: 'Oprettet af',
        sakDocuments: {
            helperText:
                'Du kan vælge filer, der skal slettes eller uploade flere filer',
            name: 'Dokumenter',
        },
        saksnummer: 'Sagsnummer',
        source: 'Kilde',
        sourceDalux: 'Dalux',
        sakImages: {
            helperText:
                'Du kan vælge billeder til sletning eller uploade flere billeder',
            name: 'Billeder',
        },
        sakLukketDato: 'Sag afsluttet på {{lukketDato}}',
        sakskategori: {
            Administration: 'Administrasjon',
            Sale: 'Salg',
            Support: 'Support',
            title: 'Kategori',
        },
        saksMelding: {
            title: '{{author}} skrev {{date}:',
        },
        sakStatus: {
            Aktiv: 'Aktiv',
            Avsluttet: 'Afsluttet',
            Sammenslått: 'Fusioneret',
            Slettet: 'Slettet',
            Unknown: 'Ukendt',
            Utsatt: 'Utsatt',
            'Venter på 3dje part': 'Venter på 3dje part',
            'Venter på kunde': 'Venter på kunde',
        },
        sakStatusSummary: {
            EjPaborjad: 'Ikke påbegyndt',
            Utskriven: 'Udskrevet',
            Utringd: 'Udtrukket',
            Kvitterad: 'Kvitteret',
            Aktiv: 'Aktive',
            Aktiv_1: 'Aktiv',
            Avsluttet: 'Afsluttede',
            Avsluttet_1: 'Afsluttet',
            Sammenslått: 'Fusionerede',
            Sammenslått_1: 'Fusioneret',
            Slettet: 'Slettede',
            Slettet_1: 'Slettet',
            Unknown: 'Ukende',
            Unknown_1: 'Ukend',
            Utsatt: 'Utsatte',
            Utsatt_1: 'Utsatt',
            'Venter på 3dje part': 'Venter på 3dje part',
            'Venter på 3dje part_1': 'Venter på 3dje part',
            'Venter på kunde': 'Venter på kunde',
            'Venter på kunde_1': 'Venter på kunde',
        },
        savingError: 'Fejl under lagring af sak',
        savingSuccess: 'Lagret',
        searchSak: 'Søg efter sager',
        showAll: 'Vis alle sager',
        status: 'Status',
        subcategory: {
            helperText: 'Vælg underkategori',
            name: 'Underkategori',
        },
        supportcategory: {
            helperText: 'Vælg supportkategori',
            name: 'Supportkategori',
        },
        summarytitle: 'Siste sager',
        tasksFor: 'Sager for {{kundeName}} ({{kundeNummer}})',
        vedlegg: {
            title: 'Vedlegg',
        },
    },
    superOffice: {
        issue: {
            new: 'Registrér ny sag',
            status: {
                temporary: 'temporary',
                todo: 'todo',
            },
            title: 'Siste sager',
        },
        langCode: 'dk',
        mytasks: 'Mine sager',
        noaccess: 'Du har ikke adgang til SuperOffice',
        opening: 'Åbner SuperOffice...',
    },
    supportForm: {
        attachments: {
            attachments: 'Last opp vedlegg',
            attachmentsHelperText: 'Velg filene som skal lastes opp',
            title: 'Vedlegg',
        },
        company: {
            companyName: 'Juridisk navn på selskap',
            companyNameHelperText: 'Skriv inn juridisk navn på selskapet',
            orgNumber: 'Organisasjonsnummer',
            orgNumberHelperText: 'Skriv inn organisasjonsnummer',
        },
        contact: 'Kontakt',
        description:
            'Forklaring hvorfor hjelper vi våre leietakere. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur massa libero, eleifend eu erat sed, consequat malesuada lacus. Suspendisse vitae neque ut lacus ultricies blandit. Pellentesque elementum, nulla quis accumsan pellentesque, enim metus sagittis justo, eget pellentesque sapien tortor at odio. Nam nulla orci, pharetra vitae dignissim in, sagittis sit amet neque. Sed sed massa eget arcu scelerisque dapibus. Suspendisse bibendum erat quis lorem maximus dignissim. Vivamus risus tortor, interdum vehicula molestie ut, tempor et felis. Vestibulum aliquam interdum lectus, et interdum lorem gravida eget. Vivamus vulputate placerat nulla, ut consectetur ante rhoncus quis. Fusce sem enim, efficitur vitae ante in, sagittis vulputate dolor. Vivamus nec massa sem. Proin in tincidunt tellus. Nulla eget leo quis nisi cursus congue.',
        economy: 'Statens kompensasjonsordning',
        email: {
            email: 'E-mail',
            emailHelperText: 'Skriv inn din e-mail',
        },
        governmentSupport: {
            amount: 'Sum',
            amountHelperText: 'Skriv inn summen her',
            caseNumber: 'Saksnummer',
            caseNumberHelperText: 'Skriv inn saksnummeret',
            governmentSupport: 'Har du fått støtte fra staten?',
            governmentSupportExplanation: 'Hvis nei, hvorfor ikke?',
            governmentSupportExplanationHelperText:
                'Fortell gjerne hvorfor du ikke har fått støtten',
            governmentSupportHelperText:
                'Velg om du har fått støtte fra staten',
            month: 'Måned',
        },
        invoice2020Q3: {
            invoiceNumber: 'Fakturanummer Q3 2020',
            invoiceNumberHelperText: 'Skriv inn fakturanummeret for Q3 2020',
        },
        kundeNummer: {
            clientNumber: 'Kundenummer hos KLP',
            clientNumberHelperText: 'Skriv inn kundenummeret hos KLP',
        },
        leietakerinformasjon: 'Leietakerinformasjon',
        other: {
            klpSupportReasonHelperText: 'Skriv din forklaring her',
            klpSupportReasonTitle:
                'Beskriv hvorfor du trenger støtte etter at statens ordning opphører',
            klpSupportReasonTitleShort: 'Begrunnelse',
            title: 'Øvrig',
        },
        personApplying: {
            personName: 'Navn på søker',
            personNameHelperText: 'Skriv inn ditt navn',
        },
        phoneNumber: {
            phoneNumber: 'Telefonnummer',
            phoneNumberHelperText: 'Skriv inn telefonnummer',
        },
        registerForm: 'Registrér søknad',
        revenue: {
            amount: 'Sum',
            amountHelperText: 'Skriv inn summen her',
            month: 'Måned',
            revenue2019: '2019',
            revenue2020: '2020',
            title: 'Omsetningstall',
        },
        shoppingCenter: {
            shoppingCenterHelperText: 'Velg senteret',
            shoppingCenterName: 'Sentertilknytning',
        },
        store: {
            storeName: 'Butikknavn',
            storeNameHelperText: 'Skriv inn butikknavnet',
        },
        support: 'Støtteordning',
        title: 'Søknad om støtte',
    },
    tables: {
        labelRowsPerPage: 'Rækker pr. side:',
    },
    user: {
        myAccount: 'Min konto',
    },
    userSearch: {
        activeUsers: 'Aktive brugere',
        addCustomer: 'Lægg til',
        addCustomerError: 'Der opstod en fejl under opdatering af kunder.',
        addCustomerSuccess: 'La til kunde {{customer}}',
        addCustomerTitle: 'Lægg til kunde',
        grantAdminError:
            'Kunne ikke give administrator rettigheder til {{email}}.',
        grantAdminQuestion:
            'Vil du give administrator rettigheder til {{email}}?',
        grantAdminSuccess: 'Gav administrator rettigheder til {{email}}.',
        grantSuperUserError:
            'Kunne ikke give superbruger rettigheder til {{email}}.',
        grantSuperUserQuestion:
            'Vil du give superbruger rettigheder til {{email}}?',
        grantSuperUserSuccess: 'Gav superbruger rettigheder til {{email}}.',
        grantSuperUserTooltip:
            'Gir eller fjerner rettigheder til kontrakt og faktura',
        inActiveUsers: 'Inaktive brugere',
        invitationNotSent: 'Ikke sendt',
        invitationSent: 'Invitasjon sendt',
        invite: 'Inviter',
        inviteActivateUser: 'Inviter/aktiver bruger',
        inviteUserError:
            'Der oppstod en fejl under afsendelse af invitasjon til {{email}}.',
        inviteUserQuestion: 'Vil du sende en invitasjon til {{email}}?',
        inviteUserSuccess: 'Sending av invitasjon til {{email}} var vellykket.',
        refreshingList: 'Opdaterer listen...',
        removeCustomerError: 'Der opstod en fejl under opdatering af bruker.',
        removeCustomerQuestion:
            'Vil du fjerne tilgang til kunde {{customer}} for {{email}}?',
        removeCustomerSuccess: 'Fjernet kunde {{customer}}',
        removeUserSuccess: 'Slettet adgang til {{user}}',
        removeUserError: 'Kunne ikke slette bruger',
        removeCustomerTitle: 'Fjern kundetilgang',
        removeUserTitle: 'Fjern brugeradgang',
        removeUserQuestion: 'Vil du slette bruger {{email}}?',
        remove: 'Fjern',
        revokeAdminError:
            'Kunne ikke fjerne administrator rettigheder for {{email}}.',
        revokeAdminQuestion:
            'Vil du fjerne administrator rettigheder for {{email}}?',
        revokeAdminSuccess: 'Fjernet administrator rettigheder for {{email}}.',
        revokeSuperUserError:
            'Kunne ikke fjerne superbruger rettigheder for {{email}}.',
        revokeSuperUserQuestion:
            'Vil du fjerne superbruger rettigheder for {{email}}?',
        revokeSuperUserSuccess:
            'Fjernet superbruger rettigheder for {{email}}.',
        searchPlaceholder: 'Søg',
        searchResults: 'Søgeresultat ({{count}} hits)',
        searchResults_1: 'Søgeresultat ({{count}} hit)',
        searchTitle: 'Søg efter brugere',
        send: 'Send',
        sendNewWelcomeMessage: 'Send ny velkomstbesked',
        sendWelcomeMessageError:
            'Der opstod en fejl under afsendelse af velkomstbesked til {{email}}.',
        sendWelcomeMessageQuestion:
            'Vil du sende velkomstbesked til {{email}}?',
        sendWelcomeMessageSuccess: 'Velkomstbesked blev sendt til {{email}}.',
        userCustomers: 'Kunder',
        userEmail: 'E-mail',
        userFirstName: 'Fornavn',
        userIsAdmin: 'Adminbruger',
        userIsSuperUser: 'Superbruger',
        userIsOrdinaryUser: 'Almindelig bruger',
        userLastName: 'Efternavn',
        welcomeMessageSent: 'Velkomstbesked sendt',
        grantSuperUser: 'Giv superbrugeradgang',
        grantAdminUser: 'Giv admin brugeradgang',
        revokeSuperUser: 'Fjern superbrugeradgang',
        revokeAdminUser: 'Fjern admin brugeradgang',
        role: 'Rolle',
        action: 'Handling',
    },
    validator: {
        email: 'Gyldig e-mail er påkrævet!',
        required: 'Felt er påkrævet! ',
    },
};
